import { HiFormControl, HiSelect } from '@hipay/design-system/components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { updateAuthenticationIndicator } from '../../actions/sdkConfigActions';
import { getPaymentDraftConfig } from '../../selectors/configSelectors';
import authenticationIndicator from './AuthenticationIndicator.const.js';

const authenticationIndicatorBuilderWithIntl = (intl, product) => {
  return {
    id: product,
    label: intl.formatMessage({ id: `authentication_indicator_${product}` })
  };
};

function AuthenticationIndicator(props) {
  const authenticationIndicatorList = authenticationIndicator.map((product) =>
    authenticationIndicatorBuilderWithIntl(props.intl, product)
  );

  const updateAuthenticationIndicator = (value) => {
    props.updateAuthenticationIndicator('authentication_indicator', value);
  };

  return (
    <>
      <h3>
        <FormattedMessage id={'3ds'} />
      </h3>
      <HiFormControl
        id="authentication_indicator"
        name="authentication_indicator"
        label={props.intl.formatMessage({
          id: 'authentication_indicator'
        })}
      >
        <HiSelect
          options={authenticationIndicatorList}
          value={props.config.authentication_indicator}
          onChange={updateAuthenticationIndicator}
          searchable={false}
        />
      </HiFormControl>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    config: getPaymentDraftConfig(state)
  };
};

export default connect(mapStateToProps, {
  updateAuthenticationIndicator
})(injectIntl(AuthenticationIndicator));
